import { isFunction } from 'lodash';
import React, { PureComponent } from 'react';

import CropArea from './CropArea';
import Screenshot from './Screenshot';

class ScreenCropper extends PureComponent {
  handleCrop = (data) => async (boundary) => {
    const { onTakeScreenshot } = this.props;
    const file = await Screenshot.cropImage(data, boundary);

    if (isFunction(onTakeScreenshot)) onTakeScreenshot(file);
  };

  render() {
    const { handleCrop } = this;
    const { open, data } = this.props;

    if (!open) return null;

    return (
      <div>
        <CropArea data={data} onCrop={handleCrop(data)} />
      </div>
    );
  }
}

export default ScreenCropper;
